import apiService from '@/state/services/Api'
import _cloneDeep from 'lodash-es/cloneDeep.js';

const URL_PLANS = 'plans'
const URL_SUBSCRIPTIONS = 'companies/:company_id/subscriptions'

const state = {
  plans: [],
  subscriptions: []
}

const getters = {

  // ===================================
  // Plans
  // ===================================

  getPlans(state) { return _cloneDeep(state.plans) },

  // ===================================
  // Subscriptions
  // ===================================

  getSubscriptions(state) { return _cloneDeep(state.subscriptions) },

  getSubscriptionById: (state) => (id) => {
    return _cloneDeep(state.subscriptions.find(e => e.id === id));
  },

}

const mutations = {

  // ===================================
  // Plans
  // ===================================

  SET_PLANS(state, plans) {
    state.plans = _cloneDeep(plans)
  },

  // ===================================
  // Subscriptions
  // ===================================

  SET_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = _cloneDeep(subscriptions)
  },

  ADD_SUBSCRIPTION(state, subscription) {
    state.subscriptions.push(_cloneDeep(subscription))
  },

  REPLACE_SUBSCRIPTION(state, subscription) {
    state.subscriptions = state.subscriptions
      .map(e => e.id === subscription.id ? _cloneDeep(subscription) : e);
  },

  REMOVE_SUBSCRIPTION(state, id) {
    state.subscriptions = state.subscriptions.filter(e => e.id !== id)
  }

}

const actions = {

  // ===================================
  // Plans
  // ===================================

  async getPlans({ commit }) {
    try {
      commit('SET_PLANS', []);
      const response = await apiService.get(URL_PLANS);
      commit('SET_PLANS', response.results)
    } catch (e) {
      return Promise.reject(e);
    }
  },

  // ===================================
  // Subscriptions
  // ===================================

  async list({ commit }, company_id) {
    try {
      commit('SET_SUBSCRIPTIONS', []);
      const URL = URL_SUBSCRIPTIONS.replace(':company_id', company_id);
      const response = await apiService.get(URL);
      commit('SET_SUBSCRIPTIONS', response.results)
      return Promise.resolve(response.results);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async getById({ commit }, payload) {
    try {
      const { company_id, subscription_id } = payload;
      const URL = `${URL_SUBSCRIPTIONS.replace(':company_id', company_id)}/${subscription_id}`;
      const subscription = await apiService.get(URL);
      commit('REPLACE_SUBSCRIPTION', subscription);
      return Promise.resolve(subscription);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async create({ commit }, payload) {
    try {
      const { company_id, subscription } = payload;
      const URL = URL_SUBSCRIPTIONS.replace(':company_id', company_id);
      const createdSubscription = await apiService.post(URL, subscription);
      commit('ADD_SUBSCRIPTION', createdSubscription);
      return Promise.resolve(createdSubscription);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async update({ commit }, payload) {
    try {
      const { company_id, subscription_id, values } = payload;
      const URL = `${URL_SUBSCRIPTIONS.replace(':company_id', company_id)}/${subscription_id}`;
      const updatedSubscription = await apiService.patch(URL, values);
      commit('REPLACE_SUBSCRIPTION', updatedSubscription);
      return Promise.resolve(updatedSubscription);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async delete({ commit }, payload) {
    try {
      const { company_id, subscription_id } = payload;
      const URL = `${URL_SUBSCRIPTIONS.replace(':company_id', company_id)}/${subscription_id}`;
      await apiService.delete(URL);
      commit('REMOVE_SUBSCRIPTION', subscription_id);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

}

export default { namespaced: true, state, getters, mutations, actions };
